const cueSet3 = [
    {
        "duration": 0.07425737500000018,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 368640,
        "time": 14.257416,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000018,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 384000,
        "time": 14.851475,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000018,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 399360,
        "time": 15.445534,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000018,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 407040,
        "time": 15.7425635,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 414720,
        "time": 16.039593,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 430080,
        "time": 16.633652,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 437760,
        "time": 16.9306815,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 445440,
        "time": 17.227711,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 460800,
        "time": 17.82177,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 476160,
        "time": 18.415829,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 491520,
        "time": 19.009888,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 506880,
        "time": 19.603947,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 518400,
        "time": 20.04949125,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 522240,
        "time": 20.198006,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 537600,
        "time": 20.792065,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 549120,
        "time": 21.23760925,
        "velocity": 0.23622047244094488
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 552960,
        "time": 21.386124,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 568320,
        "time": 21.980183,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 583680,
        "time": 22.574242,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 591360,
        "time": 22.8712715,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 599040,
        "time": 23.168301,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 614400,
        "time": 23.76236,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 629760,
        "time": 24.356419,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 637440,
        "time": 24.6534485,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 645120,
        "time": 24.950478,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 660480,
        "time": 25.544537000000002,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 675840,
        "time": 26.138596,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 683520,
        "time": 26.4356255,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 691200,
        "time": 26.732655,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 702720,
        "time": 27.17819925,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 706560,
        "time": 27.326714,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 710400,
        "time": 27.47522875,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 714240,
        "time": 27.6237435,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 721920,
        "time": 27.920773,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 729600,
        "time": 28.2178025,
        "velocity": 0.23622047244094488
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 737280,
        "time": 28.514832,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 752640,
        "time": 29.108891,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 768000,
        "time": 29.70295,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 775680,
        "time": 29.9999795,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 783360,
        "time": 30.297009,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 798720,
        "time": 30.891068,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.0742573749999984,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 806400,
        "time": 31.1880975,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 814080,
        "time": 31.485127,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 829440,
        "time": 32.079186,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 844800,
        "time": 32.673245,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 860160,
        "time": 33.267304,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 875520,
        "time": 33.861363,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 887040,
        "time": 34.30690725,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 890880,
        "time": 34.455422,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 906240,
        "time": 35.049481,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 917760,
        "time": 35.49502525,
        "velocity": 0.23622047244094488
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 921600,
        "time": 35.64354,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 936960,
        "time": 36.237599,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 952320,
        "time": 36.831658,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 960000,
        "time": 37.1286875,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 967680,
        "time": 37.425717,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 983040,
        "time": 38.019776,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 998400,
        "time": 38.613835,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1006080,
        "time": 38.9108645,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1013760,
        "time": 39.207894,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1029120,
        "time": 39.801953,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1044480,
        "time": 40.396012,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1052160,
        "time": 40.6930415,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1059840,
        "time": 40.990071,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1071360,
        "time": 41.43561525,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1075200,
        "time": 41.58413,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1079040,
        "time": 41.73264475,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1082880,
        "time": 41.8811595,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1090560,
        "time": 42.178189,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1098240,
        "time": 42.4752185,
        "velocity": 0.23622047244094488
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1105920,
        "time": 42.772248,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1121280,
        "time": 43.366307,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1136640,
        "time": 43.960366,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1144320,
        "time": 44.2573955,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1152000,
        "time": 44.554425,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1167360,
        "time": 45.148484,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1175040,
        "time": 45.4455135,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1182720,
        "time": 45.742543,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1198080,
        "time": 46.336602,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1213440,
        "time": 46.930661,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1228800,
        "time": 47.52472,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1244160,
        "time": 48.118779,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1255680,
        "time": 48.56432325,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1259520,
        "time": 48.712838,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1274880,
        "time": 49.306897,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1286400,
        "time": 49.75244125,
        "velocity": 0.23622047244094488
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1290240,
        "time": 49.900956,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1305600,
        "time": 50.495015,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1320960,
        "time": 51.089074000000004,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1328640,
        "time": 51.3861035,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1336320,
        "time": 51.683133,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1351680,
        "time": 52.277192,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1367040,
        "time": 52.871251,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1374720,
        "time": 53.1682805,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1382400,
        "time": 53.46531,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1397760,
        "time": 54.059369000000004,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1413120,
        "time": 54.653428,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1420800,
        "time": 54.9504575,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1428480,
        "time": 55.247487,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1440000,
        "time": 55.69303125,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1443840,
        "time": 55.841546,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1447680,
        "time": 55.99006075,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737500000196,
        "durationTicks": 1920,
        "midi": 36,
        "name": "C2",
        "ticks": 1451520,
        "time": 56.1385755,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1459200,
        "time": 56.435605,
        "velocity": 0.6299212598425197
    },
    {
        "duration": 0.07425737499999485,
        "durationTicks": 1920,
        "midi": 39,
        "name": "D#2",
        "ticks": 1466880,
        "time": 56.7326345,
        "velocity": 0.23622047244094488
    }
];

export default cueSet3;